import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    IconButton,
    Tabs,
    Tab,
    Menu,
    MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { headingStyle } from "../../style/LapPageStyle";
import { useSelector } from "react-redux";
import DoneIcon from "@mui/icons-material/Done";
import ChatIcon from '@mui/icons-material/Chat';
import UsePatientReminderRecords from "../../helper/UsePatientReminderRecords";
import UsePatientQuery from "../../helper/UsePatientQuery";
import { postReplyQuery } from "../../connections/postApi";
import ChatCardQuery from "../Prescription/ChatCardQuery";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { menuItemStyle } from "../../style/AppointmentStyle";
import { updateQueryStatus } from "../../connections/putApi";
import { tabStyle } from "../../style/PatientReportStyle";

const PatientRecords = ({ onClose, patientId }) => {
    const patientDetailsData = useSelector(
        (state) => state.prescription.patientDetailsData
    );
    const prescriptionData = useSelector(
        (state) => state.prescription.prescriptionData
    );

    const { data: patientMedicineReminder } = UsePatientReminderRecords(patientDetailsData?.id, prescriptionData?.id)
    const { data: QueryList, refetch } = UsePatientQuery(prescriptionData?.id);

    const [selectedTab, setSelectedTab] = useState(0);
    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const handleColors = (timeSlotArray = []) => {
        console.log(timeSlotArray, 'timeSlot array')
        if (!timeSlotArray || timeSlotArray.length === 0) {
            return "grey";
        }

        const currentTime = new Date();
        let allCompleted = true;
        let allPending = true;
        let hasUpcoming = false;

        for (let med of timeSlotArray) {
            if (med.status !== "completed") {
                allCompleted = false;
            }
            if (med.status !== "pending") {
                allPending = false;
            }

            const reminderTime = new Date(med.reminder_time);
            if (reminderTime > currentTime) {
                hasUpcoming = true;
            }
        }

        if (hasUpcoming) return "black";
        if (allCompleted) return "#4DD57B"; // green
        if (allPending) return "#FF392B"; // red
        return "#ffde33"; // yellow (some completed, some pending)
    };

    const calculateDosageEfficiency = (reminders) => {
        if (!reminders || reminders.length === 0) return 0;

        let total = 0;
        let completed = 0;

        reminders.forEach(item => {
            const dateKey = Object.keys(item)[0];
            const slotData = item[dateKey];

            ['morning', 'afternoon', 'evening', 'night'].forEach(slot => {
                if (slotData[slot] && slotData[slot].length > 0) {
                    slotData[slot].forEach(med => {
                        if (med.status) {
                            total++;
                            if (med.status === 'completed') completed++;
                        }
                    });
                }
            });
        });

        return total > 0 ? Math.round((completed / total) * 100) : 0;
    };

    const [openAccordion, setOpenAccordion] = useState(null);
    // const [chatInput, setChatInput] = useState('');
    const [chatInput, setChatInput] = useState({});
    const [queries, setQueries] = useState(QueryList?.payload?.queries || []);

    useEffect(() => {
        if (QueryList?.payload?.queries) {
            setQueries(QueryList?.payload?.queries || [])
        }
    }, [QueryList])

    // console.log(queries, 'queries')
    const handleSendMessage = async (index) => {
        const query = queries[index];
        const message = chatInput[query.id];

        if (!message) return;

        const messagePayload = {
            message,
        };

        try {
            const response = await postReplyQuery(query?.id, prescriptionData?.id, messagePayload);
            // console.log(response, 'response')
            if (response?.status?.status === 'SUCCESS') {
                const updatedQueries = [...queries];
                const updatedQuery = { ...query };

                updatedQuery.query_replies = [
                    ...updatedQuery.query_replies,
                    {
                        id: Date.now(), // Temporary ID
                        repliable_type: "Specialist",
                        repliable_id: 1,
                        query_id: query.id,
                        message,
                        created_at: new Date().toISOString(),
                        updated_at: new Date().toISOString(),
                    },
                ];

                updatedQueries[index] = updatedQuery;
                setQueries(updatedQueries);
                setChatInput((prev) => ({ ...prev, [query.id]: '' }));
            } else {
                console.error("Failed to send message", response);
            }
        } catch (err) {
            console.error("Error sending message", err);
        }
    };

    const getStatusUI = (status) => {
        switch (status) {
            case 'open':
                return {
                    text: 'Open',
                    color: '#1976d2',
                    bg: '#e3f2fd',
                    Icon: ChatIcon
                };

            case 'resolved':
                return {
                    text: 'Resolved',
                    color: '#4DD57B',
                    bg: '#b4eec8',
                    Icon: DoneIcon
                };

            case 'close':
                return {
                    text: 'Closed',
                    color: '#e53935',
                    bg: '#ffebee',
                    Icon: CloseIcon
                };

            case 'in_progress':
                return {
                    text: 'In Progress',
                    color: '#fb8c00',
                    bg: '#fff3e0',
                    Icon: AutorenewIcon
                };

            default:
                return {
                    text: 'Open',
                    color: '#1976d2',
                    bg: '#e3f2fd',
                    Icon: ChatIcon
                };
        }
    };


    const [anchorEl, setAnchorEl] = React.useState(null);
    const [selectedQueryId, setSelectedQueryId] = React.useState(null);

    const handleStatusClick = (event, queryId) => {
        setAnchorEl(event.currentTarget);
        setSelectedQueryId(queryId);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setSelectedQueryId(null);
    };

    // ✅ One function to change status
    const handleChangeStatus = async (status, id) => {
        // console.log("Query ID:", selectedQueryId, "New Status:", status);
        handleCloseMenu();
        const payload = {
            query: {
                status: status
            }
        };
        try {
            const res = await updateQueryStatus(payload, id);
            if (res?.status?.status === 'SUCCESS') {
                refetch();
            }
            // console.log(res, 'res');
        } catch (error) {
            console.log(error);
        }
    };


    return (
        <Box sx={{
            width: "90vw", height: '90vh', overflowX: "auto",   /* 🔒 Hide scrollbar */
            scrollbarWidth: "none",          // Firefox
            msOverflowStyle: "none",          // IE & Edge
            "&::-webkit-scrollbar": {
                display: "none",              // Chrome, Safari
            },
        }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box></Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                        variant="heading1"
                        fontWeight={600}
                        gutterBottom
                        sx={{ ...headingStyle }}
                    >
                        Patient Records
                    </Typography>
                </Box>
                <IconButton onClick={onClose}>
                    <CloseIcon size="small" sx={{ color: "red" }} />
                </IconButton>
            </Box>

            <Box sx={{ padding: 1, mt: -1 }}>

                <Tabs value={selectedTab} onChange={handleTabChange}
                    sx={{
                        // mb: 1,
                        alignItems: "center",
                        "& .MuiTabs-flexContainer": {
                            alignItems: "center",
                        },
                        "& .MuiTabs-indicator": {
                            backgroundColor: "neutral.teal",
                            height: "2px",
                        },
                    }}>
                    <Tab label="Medicine Timeline"
                        sx={tabStyle}
                    />
                    <Tab label="Queries"
                        sx={tabStyle} />
                </Tabs>

                <Box sx={{ mt: 1 }}>
                    {selectedTab === 0 && (
                        <Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                <Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, alignItems: 'center' }}>
                                        <Typography>Dosage efficiency:</Typography>
                                        <Box sx={{ backgroundColor: 'neutral.blueShadeBg', borderRadius: 55, padding: 1, height: 'min-content' }}>
                                            <Typography>{calculateDosageEfficiency(patientMedicineReminder?.payload?.medicine_reminders)} %</Typography>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box>
                                    {[
                                        { color: '#4DD57B', label: 'Medicine Taken' },
                                        { color: '#FF392B', label: 'Medicine Missed' },
                                        { color: 'grey', label: 'No Reminder Available' },
                                        { color: '#ffde33', label: 'Some Medicine missed earlier' },
                                        { color: 'black', label: 'Upcoming reminder stay prepared' },
                                    ].map(({ color, label }) => (
                                        <Box key={label} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                            <Box sx={{ height: '12px', width: '12px', backgroundColor: color, borderRadius: 55 }}></Box>
                                            <Typography>{label}</Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>

                            {/* Reminder listing */}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 1 }}>
                                {patientMedicineReminder?.payload?.medicine_reminders?.map((item, index) => {
                                    const dateKey = Object.keys(item)[0];
                                    const trimDate = dateKey?.split(',')[1]?.trim();
                                    const [day, monthShort] = trimDate?.split(' ');

                                    const slotData = item[dateKey]; // { morning: [], afternoon: [], evening: [...], night: [] }

                                    return (
                                        <Box key={dateKey} sx={{ backgroundColor: 'neutral.blueShadeBg', borderRadius: '15px', padding: 2, textAlign: 'center' }}>
                                            <Typography>{day}</Typography>
                                            <Typography>{monthShort}</Typography>

                                            <Box sx={{ display: "flex", gap: 0.5, marginTop: 1 }}>
                                                {['morning', 'afternoon', 'evening', 'night'].map(slot => (
                                                    <Box
                                                        key={slot}
                                                        sx={{
                                                            height: '11px',
                                                            width: '11px',
                                                            backgroundColor: handleColors(slotData?.[slot]),
                                                            borderRadius: 55,
                                                        }}
                                                    />
                                                ))}
                                            </Box>
                                        </Box>
                                    );
                                })}
                                {patientMedicineReminder?.payload?.medicine_reminders?.length === 0 &&
                                    <Box sx={{ margin: 'auto' }}>
                                        <Typography>
                                            No medicine reminders found.</Typography></Box>}
                            </Box>
                        </Box>
                    )}

                    {selectedTab === 1 && (
                        <Box sx={{
                            padding: 2, display: 'flex', rowGap: 3, flexDirection: "column",
                            position: 'relative',
                        }}>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    left: 180,
                                    top: 30,
                                    bottom: 30,
                                    width: '2px',
                                    backgroundColor: 'neutral.teal',
                                    // zIndex: 10,
                                }}
                            />
                            {queries?.map((query, index) => {
                                const isOpen = openAccordion === index;
                                return (
                                    <Box key={index} sx={{ display: 'flex', gap: 2, flexDirection: 'column', zIndex: 10, }}>
                                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                            <Typography variant="subTitle116px" sx={{ minWidth: '100px' }}>{new Date(query?.created_at).toLocaleDateString('en-US', {
                                                month: 'short',
                                                day: 'numeric',
                                                year: 'numeric',
                                            })
                                            }</Typography>

                                            {(() => {
                                                const { text, color, bg, Icon } = getStatusUI(query?.status);

                                                return (
                                                    <Box
                                                        onClick={(e) => handleStatusClick(e, query?.id)}
                                                        sx={{
                                                            display: 'flex',
                                                            backgroundColor: "neutral.blueShadeBg",
                                                            width: '100px',
                                                            borderRadius: '10px',
                                                            padding: 1,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            flexDirection: 'column',
                                                            gap: 0.5,
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <Icon
                                                            sx={{
                                                                color,
                                                                backgroundColor: bg,
                                                                borderRadius: 55,
                                                                padding: 0.5,
                                                                width: '16px',
                                                                height: '16px'
                                                            }}
                                                        />
                                                        <Typography variant='body_Grey' sx={{ color }}>
                                                            {text}
                                                        </Typography>
                                                    </Box>
                                                );
                                            })()}


                                            <Box sx={{ backgroundColor: 'neutral.blueShadeBg', display: 'flex', justifyContent: 'space-between', padding: 1.5, gap: 6, alignItems: 'center', borderRadius: '10px', width: '100%' }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                    <Typography variant="subTitle116px">{query.title}</Typography>
                                                    <Typography variant="body_Grey1" sx={{ color: '#7A7A7A' }}>{query.description}</Typography>
                                                </Box>

                                                <IconButton onClick={() => setOpenAccordion(isOpen ? null : index)}>
                                                    {isOpen ? <CloseIcon sx={{ color: 'red' }} /> : <ChatIcon sx={{ color: 'neutral.teal', height: '30px', width: '30px' }} />}
                                                </IconButton>
                                            </Box>
                                        </Box>

                                        {isOpen && (
                                            <Box sx={{ backgroundColor: 'neutral.blueShadeBg', borderRadius: '10px', padding: 1, width: '80%', alignSelf: "flex-end" }}>
                                                <ChatCardQuery id={query?.id} fromParticularPatient={true} />
                                            </Box>
                                        )}
                                    </Box>
                                );
                            })}
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleCloseMenu}

                            >
                                <MenuItem onClick={() => handleChangeStatus('open', selectedQueryId)} sx={menuItemStyle}>Open</MenuItem>
                                <MenuItem onClick={() => handleChangeStatus('resolved', selectedQueryId)} sx={menuItemStyle}>Resolved</MenuItem>
                                <MenuItem onClick={() => handleChangeStatus('in_progress', selectedQueryId)} sx={menuItemStyle}>Progress</MenuItem>
                            </Menu>

                            {queries?.length === 0
                                &&
                                <Box sx={{ margin: 'auto' }}>
                                    <Typography>
                                        No queries yet.
                                    </Typography>
                                </Box>}

                        </Box>
                    )}
                </Box>
            </Box>

        </Box >
    );
};
export default PatientRecords;
